import 'primereact/resources/themes/lara-light-indigo/theme.css';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import 'bootstrap/dist/css/bootstrap.css';
import { Routes, Route } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';
import { adminRoutes } from './routes';
import AdminRoutes from "./Routes/AdminRoutes";
import ProtectedRoute from './ProtectedRoute';
import Login from './pages/Login';
import Privacy from './pages/Privacy';
import Support from './pages/Support';
 
function App() {
  const toast = useRef(null);
 
  return (
    <>
      <Toast ref={toast} />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/support" element={<Support />} />
        <Route path="/admin" element={<AdminRoutes />}>
          {adminRoutes.map(({ path, element, permission }, index) => (
            <Route
              key={index}
              path={path}
              element={
                permission ? (
                  <ProtectedRoute requiredPermission={permission}>
                    {element}
                  </ProtectedRoute>
                ) : (
                  element
                )
              }
            />
          ))}
        </Route>
      </Routes>
    </>
  );
}
 
export default App;